import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Mail } from "lucide-react";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { apiLogin } from "../lib/api";
import Logo from "../components/Logo";
import { toast } from "sonner";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await apiLogin(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafbfc] p-6">
      <div className="w-full max-w-md bg-white border border-gray-200 shadow-lg">
        <div className="h-1 bg-[#b91c1c]" />
        <div className="p-10">
          <div className="flex justify-center mb-5"><Logo size={56} /></div>
          <div className="text-center mb-8">
            <div className="text-[10px] font-semibold tracking-[0.32em] uppercase text-[#b91c1c] mb-2">Admin Portal</div>
            <h1 className="font-display text-3xl font-semibold text-[#0a0a0a] tracking-tight">Sign in</h1>
          </div>
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="text-[11px] font-semibold tracking-[0.18em] uppercase text-gray-500">Email</label>
              <div className="relative mt-1">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="pl-9 h-11 rounded-none border-gray-300" />
              </div>
            </div>
            <div>
              <label className="text-[11px] font-semibold tracking-[0.18em] uppercase text-gray-500">Password</label>
              <div className="relative mt-1">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="pl-9 h-11 rounded-none border-gray-300" />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-12 rounded-none btn-primary text-[12px] font-semibold uppercase tracking-[0.18em]">
              {loading ? "Signing in…" : "Sign In"}
            </Button>
          </form>
          <p className="mt-6 text-[10px] uppercase tracking-[0.2em] text-gray-400 text-center">Authorized personnel only</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
